import { node as patientCondition } from "src/modules/kd/forms/patientCondition";
import { node as basicRegistrationData } from "src/modules/ktx/forms/basic-registration-data";
import { node as transplantationScreening } from "src/modules/ktx/forms/transplantation-screening";
import { LeafNode, ParentNode } from "src/modules/shared/form-explorer";

export const forms: (ParentNode | LeafNode)[] = [
	basicRegistrationData,
	transplantationScreening,
	patientCondition
];
